import { render, staticRenderFns } from "./MoyasarInlineApplePay.vue?vue&type=template&id=1885d940&scoped=true"
import script from "./MoyasarInlineApplePay.vue?vue&type=script&lang=js"
export * from "./MoyasarInlineApplePay.vue?vue&type=script&lang=js"
import style0 from "./MoyasarInlineApplePay.vue?vue&type=style&index=0&id=1885d940&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1885d940",
  null
  
)

export default component.exports